export const ActivationSource = {
    None: 0,
    MainMenu: 1,
    PersonalMenu: 2,
    ExternalLink: 3,
    InternalLink: 4,
    SearchResult: 5,
    PersonalMenuAdd: 6,
    PersonalMenuQuary: 7,
    QuickSearch: 8,
    Analytics: 9,
    EOYWizard: 10,
    ADP: 11
};
